
      // This file is Patrol's band-aid solution for temporarily unavailable or difficult automated source code fixes. 
      // Hence, all accessibility concerns caused by third-parties where we can't access the source code will be addressed here.
      // Patrol strives to fix issues invisibly in the online theme source code where possible.
      // We are constantly improving our accessibility automatation and appreciate any learnings of blind spots to address.
      // Please email us at support@patrolapp.ai if you have any concerns.
      
      


function improveAriaLabel_01875c19c9114310be84432243cbfb7a() {
  const ariaLabelMap = [["a[target=\"_blank\"]",{"selector":"a[target=\"_blank\"]","label":""}]];
  const selectorRouteMap = {"a[target=\"_blank\"]":["/collections/all"]};

  function traverseSpecificElement(root, selector, callback) {
    const parts = selector.split('>>').map(s => s.trim());
    let currentElements = [root];

    for (const part of parts) {
      if (currentElements.length === 0) break;

      const nextElements = [];
      for (const element of currentElements) {
        if (element instanceof Document || element instanceof DocumentFragment) {
          nextElements.push(...element.querySelectorAll(part));
        } else if (element instanceof HTMLIFrameElement && element.contentDocument) {
          nextElements.push(...element.contentDocument.querySelectorAll(part));
        } else if (element.shadowRoot) {
          nextElements.push(...element.shadowRoot.querySelectorAll(part));
        } else {
          nextElements.push(...element.querySelectorAll(part));
          // Check for slotted elements
          if (element.assignedElements) {
            const slottedElements = element.assignedElements({ flatten: true });
            nextElements.push(...slottedElements.filter(el => el.matches(part)));
          }
        }
      }
      currentElements = nextElements;
    }

    currentElements.forEach(callback);
  }

  function isCurrentPageInRoutes(routes) {
      const currentPath = window.location.pathname;
      const result = routes.some(route => {
          const routeRegex = new RegExp('^' + route.replace(/\*/g, '.*') + '$');
          return routeRegex.test(currentPath);
      });
      return result;
  }

  ariaLabelMap.forEach(([selector, value]) => {
    const routes = selectorRouteMap[selector];
    if (!routes || isCurrentPageInRoutes(routes)) {
      traverseSpecificElement(document, selector, (el) => {
        el.setAttribute('aria-label', value.label);
        el.setAttribute('data-aria-label-added', '01875c19c9114310be84432243cbfb7a');
      });
    }
  });
}

// Run the function when the DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', improveAriaLabel_01875c19c9114310be84432243cbfb7a);
} else {
  improveAriaLabel_01875c19c9114310be84432243cbfb7a();
}

// Rerun the function when the DOM changes
const observer_01875c19c9114310be84432243cbfb7a = new MutationObserver(() => {
  improveAriaLabel_01875c19c9114310be84432243cbfb7a();
});
observer_01875c19c9114310be84432243cbfb7a.observe(document.body, { childList: true, subtree: true });


function fixAccessibility_533fa96f120e4d9c8434143f60ba22b5() {
    const descriptionId = 'new-window-description';
    const descriptionText = 'Opens in a new window';

    // Create a hidden description element if it doesn't exist
    if (!document.getElementById(descriptionId)) {
        const descriptionElement = document.createElement('div');
        descriptionElement.id = descriptionId;
        descriptionElement.textContent = descriptionText;
        descriptionElement.style.position = 'absolute';
        descriptionElement.style.width = '1px';
        descriptionElement.style.height = '1px';
        descriptionElement.style.overflow = 'hidden';
        descriptionElement.style.clip = 'rect(1px, 1px, 1px, 1px)';
        descriptionElement.style.clipPath = 'inset(50%)';
        descriptionElement.style.whiteSpace = 'nowrap';
        descriptionElement.style.border = '0';
        document.body.appendChild(descriptionElement);
    }

    function applyFixToLinks() {
        const links = document.querySelectorAll('a[target="_blank"]:not([data-accessibility-fix="533fa96f120e4d9c8434143f60ba22b5"])');
        links.forEach(link => {
            link.setAttribute('aria-describedby', descriptionId);
            link.setAttribute('data-accessibility-fix', '533fa96f120e4d9c8434143f60ba22b5');
        });

        if (links.length === 0) {
            clearInterval(intervalId);
        }
    }

    const intervalId = setInterval(applyFixToLinks, 1000);

    // Listen for messages from iframes
    window.addEventListener('message', (event) => {
        if (event.data === 'applyAccessibilityFix') {
            applyFixToLinks();
        }
    }, false);
}

fixAccessibility_533fa96f120e4d9c8434143f60ba22b5();